import { createBrowserHistory } from 'history';
import { combineReducers } from 'redux';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';

import ndesReducer from './ndes/ndes';
import globalReducer from './global/global';
import blogAuthReducer from './blog/blogAuth';

const {
  createReduxHistory,
  routerMiddleware,
  routerReducer
} = createReduxHistoryContext({ history: createBrowserHistory() });

const rootReducer = combineReducers({
  global: globalReducer,
  ndes: ndesReducer,
  blogAuth: blogAuthReducer,
  router: routerReducer
});

const store = configureStore({
  reducer: rootReducer,
  middleware: [...getDefaultMiddleware(), routerMiddleware]
});

export const history = createReduxHistory(store);
export default store;
